import { Outlet } from "react-router-dom";
import { Header } from "./Header";

export default function HeaderBase() {
    return <>
        <Header></Header>
        <Outlet></Outlet>
    </>
}